import { ForgotPasswordWizard } from "./forgot-password-wizard";
import "./styles.scss";

export const ForgotPasswordPage = () => {
  return (
    <div className="page forgot-password-page">
      <div className="forgot-password-content-wrapper">
        <div className="forgot-password-form">
          <ForgotPasswordWizard />
        </div>
      </div>
    </div>
  );
};

